import React from "react";
import hippaLogo from "./hippaLogo.png";

// Content from the main footer
const products = [
  { name: "Scheduling Well", href: "https://www.samarawell.com/products#scheduling" },
  { name: "Reviews Well", href: "https://www.samarawell.com/products#reviews" },
  { name: "Communication Well", href: "https://www.samarawell.com/products#communication" },
  { name: "Connections Well", href: "https://www.samarawell.com/products#connections" },
  { name: "Insights Well", href: "https://www.samarawell.com/products#insights" },
  { name: "Roadmap", href: "https://www.samarawell.com/products#roadmap" },
];

const outpatient = [
  { name: "Medical", href: "https://www.samarawell.com/medical" },
  { name: "Dental", href: "https://www.samarawell.com/dental" },
  { name: "Mental Health", href: "https://www.samarawell.com/mentalhealth" },
  { name: "Chiropractic", href: "https://www.samarawell.com/chiropractic" },
  { name: "Eye Care", href: "https://www.samarawell.com/eyecare" },
  { name: "Med Spa", href: "https://www.samarawell.com/medspa" },
];

const resources = [
  { name: "FAQ", href: "https://www.samarawell.com/faqs" },
  { name: "Testimonials", href: "https://www.samarawell.com/testimonials" },
  { name: "Contact", href: "https://www.samarawell.com/contact" },
];

const platform = [
  { name: "Provider Portal", href: "https://console.samarawell.com/signin?redirect=%2Fdashboards%2Fhome" },
  { name: "Patient Portal", href: "https://app.samarawell.com/patientLanding" },
  { name: "Pricing", href: "https://www.samarawell.com/pricing" },
  { name: "Demo", href: "https://www.samarawell.com/bookdemo" },
];

function ProviderLandingPageFooter() {
  return (
    <footer className="w-full bg-blueColor text-white font-fontPoppins pt-12 pb-2">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-start">
          <div className="pt-4 w-full flex flex-wrap justify-between items-start border-b border-white-600 pb-5">
            <div className="flex-1 min-w-[200px] mb-4">
              <h4 className="text-lg font-semibold mb-4">PRODUCTS</h4>
              <ul>
                {products.map((product) => (
                  <li key={product.name} className="mb-2">
                    <a
                      href={product.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-paleTurquoise active:text-steelBlue transition duration-300"
                    >
                      {product.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="flex-1 min-w-[200px] mb-4">
              <h4 className="text-lg font-semibold mb-4">OUTPATIENT CARE</h4>
              <ul>
                {outpatient.map((item) => (
                  <li key={item.name} className="mb-2">
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-paleTurquoise active:text-steelBlue transition duration-300"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="flex-1 min-w-[200px] mb-4">
              <h4 className="text-lg font-semibold mb-4">RESOURCES</h4>
              <ul>
                {resources.map((item) => (
                  <li key={item.name} className="mb-2">
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-paleTurquoise active:text-steelBlue transition duration-300"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="flex-1 min-w-[200px] mb-4">
              <h4 className="text-lg font-semibold mb-4">PLATFORM</h4>
              <ul>
                {platform.map((item) => (
                    <li key={item.name} className="mb-2">
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-paleTurquoise active:text-steelBlue transition duration-300"
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
            
            <div className="flex-1 min-w-[200px] mb-4">
              <div className="">
                <img src={hippaLogo} alt="HIPAA Compliant" className="w-32 mb-4" />
              </div>
            </div>
          </div>
          
          <div className="w-full flex justify-between items-center pt-8">
            <div className="">
              <p>&copy; Samara. All rights reserved 2025</p>
            </div>

            <nav className="ms-auto xss:text-center sm:text-center">
              <a
                href="https://www.samarawell.com/hippa"
                target="_blank"
                rel="noopener noreferrer"
                className="font-fontPoppins"
              >
                HIPAA Compliant Digital Health
              </a>

              <span className="font-fontPoppins"> | </span>

              <a
                href="https://www.samarawell.com/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                className="font-fontPoppins"
              >
                Privacy Policy
              </a>

              <span className="font-fontPoppins"> | </span>

              <a
                href="https://www.samarawell.com/termsofservice"
                target="_blank"
                rel="noopener noreferrer"
                className="font-fontPoppins"
              >
                Terms Of Service
              </a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default ProviderLandingPageFooter;